import React from "react";

const FlatThreeDot = ({
    width = 16,
    height = 4,
    viewBox = "0 0 8 2",
    fill = "none",
    xmlns = "http://www.w3.org/2000/svg",
    pathFill = "#727580",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        xmlns={xmlns}
        {...props}
    >
        <path 
            d="M7.00292 0C7.27875 0 7.51389 0.0981944 7.70833 0.294583C7.90278 0.490972 8 0.727083 8 1.00292C8 1.27875 7.90181 1.51389 7.70542 1.70833C7.50903 1.90278 7.27292 2 6.99708 2C6.72125 2 6.48611 1.90181 6.29167 1.70542C6.09722 1.50903 6 1.27292 6 0.997083C6 0.72125 6.09819 0.486111 6.29458 0.291667C6.49097 0.0972222 6.72708 0 7.00292 0ZM4.00292 0C4.27875 0 4.51389 0.0981944 4.70833 0.294583C4.90278 0.490972 5 0.727083 5 1.00292C5 1.27875 4.90181 1.51389 4.70542 1.70833C4.50903 1.90278 4.27292 2 3.99708 2C3.72125 2 3.48611 1.90181 3.29167 1.70542C3.09722 1.50903 3 1.27292 3 0.997083C3 0.72125 3.0982 0.486111 3.29458 0.291667C3.49097 0.0972222 3.72708 0 4.00292 0ZM1.00292 0C1.27875 0 1.51389 0.0981944 1.70833 0.294583C1.90278 0.490972 2 0.727083 2 1.00292C2 1.27875 1.9018 1.51389 1.70542 1.70833C1.50903 1.90278 1.27292 2 0.997083 2C0.72125 2 0.486111 1.90181 0.291667 1.70542C0.0972219 1.50903 0 1.27292 0 0.997083C0 0.72125 0.0981951 0.486111 0.294584 0.291667C0.490973 0.0972222 0.727084 0 1.00292 0Z" 
            fill="#727580"
            className={props?.className}
        />
    </svg>
);

export default FlatThreeDot;